import { doc, setDoc, onSnapshot, serverTimestamp, type Unsubscribe } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { logSyncError } from './syncErrors';

export interface UserProfile {
  displayName: string | null;
  email: string | null;
  provider: 'google' | 'apple';
  scheduleStyle: string | null;
  energyPattern: object | null;
  onboardingComplete: boolean;
  nudgeDismissedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
}

function profileDoc(uid: string) {
  return doc(db, 'users', uid, 'profile', 'main');
}

export function startProfileSync(uid: string): Unsubscribe {
  return onSnapshot(
    profileDoc(uid),
    () => {
      // Profile data is read-only in the client for now.
      // Future phases will hydrate a profile store here.
    },
    logSyncError('profileSync', uid),
  );
}

export async function writeProfile(uid: string, profile: Partial<UserProfile>): Promise<void> {
  await setDoc(
    profileDoc(uid),
    { ...profile, serverUpdatedAt: serverTimestamp() },
    { merge: true },
  );
}
